// src/lib/layouts/buildLayoutRenderInput.ts
import type { PostLayoutBlob, PostLayoutConfig } from './types';

export interface LayoutSelection {
  postLayout: PostLayoutConfig | null;
  speakerLayout: number;
  uniqueSpeakerCount: number;
}

export interface LayoutRenderInput {
  post_layout?: PostLayoutBlob;
  speaker_layout?: number;
}

/** Post-frame and speaker-split are mutually exclusive; post-frame wins when set. */
export function buildLayoutRenderInput(sel: LayoutSelection): LayoutRenderInput {
  if (sel.postLayout) {
    const { kind, ...config } = sel.postLayout;
    return { post_layout: { kind, config: config as Record<string, unknown> } };
  }
  if (sel.speakerLayout > 1 && sel.uniqueSpeakerCount > 1) {
    return { speaker_layout: sel.speakerLayout };
  }
  return {};
}
